import React, { useState, useContext, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from "@material-ui/core/styles";
import { useAuth } from "react-oidc-context";
import { LayoutContext } from 'App/Layout/store'

const styles = theme => ({
});

function ConfirmBorrador(props) {

  const [enviando, setEnviando] = useState(false);
  const auth = useAuth();
  const layoutContext = useContext(LayoutContext)

  var esAdmin = layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre.startsWith("Administracion") && p.BLectura+p.BEscritura)

  useEffect(()=>{
    if(props.open){
      setEnviando(false);
    }
  },[props.open])

  return (
    <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{!esAdmin?
              "Emitir Documento"
              :
              "Enviar o Guardar Documento"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {!esAdmin?
              "¿Está seguro que desea emitir este documento?"
              :
              "¿Desea guardar como borrador o enviar directo al SII?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={props.handleClose} color="default">
                Cancelar
            </Button>
            {esAdmin &&
            <Button onClick={()=> { setEnviando(true); props.guardarDTE(true) }} color="default">
                Guardar
            </Button>
            }
            <Button onClick={()=> { setEnviando(true); props.guardarDTE(false) }} color="primary" autoFocus>
            {!esAdmin?
              "Emitir"
              :
              "Guardar y Enviar"}
            </Button>
        </DialogActions>
      </Dialog>
  );
}

export default withStyles(styles)(ConfirmBorrador);